import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { useStudentView } from '../context/StudentViewContext';
import ConfirmDialog from './ConfirmDialog';

function StudentViewBar() {
  const { isActive, studentViewState, deactivate, reset } = useStudentView();
  const [resetConfirmOpen, setResetConfirmOpen] = useState(false);

  if (!isActive) return null;

  const handleReset = async () => {
    setResetConfirmOpen(false);
    await reset();
    window.location.reload();
  };

  return (
    <>
      <Box
        role="status"
        aria-live="polite"
        aria-label="Student View mode is active"
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          bgcolor: 'warning.main',
          color: '#0F172A',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          px: 3,
          py: 1.5,
          flexWrap: 'wrap',
        }}
      >
        <VisibilityIcon sx={{ color: '#0F172A' }} />
        <Typography
          sx={{ fontWeight: 600, fontSize: '0.9rem', color: '#0F172A', display: 'flex', alignItems: 'center', gap: 1 }}
        >
          You are viewing the course as
          <Chip
            label={studentViewState?.testStudentName || 'Test Student'}
            size="small"
            sx={{
              fontWeight: 700,
              bgcolor: 'rgba(0,0,0,0.15)',
              color: '#0F172A',
            }}
          />
        </Typography>
        <Button
          variant="contained"
          size="small"
          startIcon={<ExitToAppIcon />}
          onClick={deactivate}
          sx={{
            bgcolor: '#0F172A',
            color: 'warning.main',
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': { bgcolor: '#1E293B' },
            '&:focus-visible': {
              outline: '2px solid #0F172A',
              outlineOffset: 2,
            },
          }}
        >
          Leave Student View
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<RestartAltIcon />}
          onClick={() => setResetConfirmOpen(true)}
          sx={{
            borderColor: '#0F172A',
            color: '#0F172A',
            fontWeight: 600,
            textTransform: 'none',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.1)', borderColor: '#0F172A' },
            '&:focus-visible': {
              outline: '2px solid #0F172A',
              outlineOffset: 2,
            },
          }}
        >
          Reset Student
        </Button>
      </Box>
      <ConfirmDialog
        open={resetConfirmOpen}
        onClose={() => setResetConfirmOpen(false)}
        onConfirm={handleReset}
        title="Reset Test Student"
        message="This will delete all submissions, grades, and progress for the Test Student in this course. This action cannot be undone."
        confirmLabel="Reset"
        severity="warning"
      />
    </>
  );
}

export default StudentViewBar;
